import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core'
import { QmaConstant } from '../../constant/qma-constant';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { TabDataService } from '../../services/tab-data.service';

@Component({
  selector: 'app-megamenureport',
  templateUrl: './megamenureport.component.html',
  styleUrl: './megamenureport.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenureportComponent {
  reportTypes = QmaConstant.QMA_REPORT_TYPES;
  dashboardTypes = QmaConstant.QMA_MIS_DASHBOARD_TYPES;
  reportsOptions = ['Inquiry Reports', 'Management Report']

  @ViewChild('contextMenuContainer') contextMenuContainer: ElementRef;
  @Output() onItemSelect = new EventEmitter();

  constructor(private readonly sideNavmponent: SidenavComponent, private readonly tabDataService:TabDataService) {
  }
  itemSelected(item) {
    if (item === 'Inquiry Reports') {
      this.sideNavmponent.onClickMenuItem('inquiry-reports');
      this.tabDataService.setMessageMenuToggleFalse();
    } else if (item === 'Management Report') {
      this.tabDataService.sendTabData('Management Report', 0, 'report', '', true);
      this.tabDataService.setMessageMenuToggleFalse();
    }
  }
}
